import React from 'react';

// Design System Components
import SegmentedControl from 'Components/DesignSystem/SegmentedControl/SegmentedControl';

// Module Components
import SectionHeading from './SectionHeading';

// Constants
import { STRINGS, isDescriptionStyle } from '../../../constants';

// Types
import { DescriptionStyle } from '../../../types';

interface DescriptionStyleSectionProps {
  descStyle: DescriptionStyle;
  onDescriptionStyleChange: (descStyle: DescriptionStyle) => void;
}

const DESCRIPTION_STYLE_OPTIONS: { value: DescriptionStyle; label: string }[] = [
  { value: 'partly', label: STRINGS.pane.descriptionStylePartly },
  { value: 'full', label: STRINGS.pane.descriptionStyleFull },
  { value: 'collapsed', label: STRINGS.pane.descriptionStyleCollapsed },
];

/**
 * The Short Description's Description style section (spec R71): Clamp 2 lines,
 * Full, or Collapsed, exactly one selected, Clamp 2 lines by default.
 *
 * The same segmented single-choice shape as Alignment and Image display, per the
 * round-4 gate's decision on Q25.
 */
const DescriptionStyleSection = ({
  descStyle,
  onDescriptionStyleChange,
}: DescriptionStyleSectionProps) => (
  <div className="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3 tw-border-b tw-border-edge">
    <SectionHeading as="h4">{STRINGS.pane.descriptionStyle}</SectionHeading>

    <SegmentedControl
      data-testid="product-card-description-style"
      ariaLabel={STRINGS.pane.descriptionStyle}
      options={DESCRIPTION_STYLE_OPTIONS.map((option) => ({ id: option.value, label: option.label }))}
      value={descStyle}
      onChange={(id) => {
        const value = String(id);
        if (isDescriptionStyle(value)) {
          onDescriptionStyleChange(value);
        }
      }}
    />
  </div>
);

export default DescriptionStyleSection;
